import { render, staticRenderFns } from "./TheSection.vue?vue&type=template&id=0d8653aa&scoped=true"
import script from "./TheSection.vue?vue&type=script&lang=js"
export * from "./TheSection.vue?vue&type=script&lang=js"
import style0 from "./TheSection.vue?vue&type=style&index=0&id=0d8653aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8653aa",
  null
  
)

export default component.exports